import { render, staticRenderFns } from "./onlineExpo.vue?vue&type=template&id=24d178f9&"
import script from "./onlineExpo.vue?vue&type=script&lang=js&"
export * from "./onlineExpo.vue?vue&type=script&lang=js&"
import style0 from "./onlineExpo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports